var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ix-form-input-venture-table',{attrs:{"headers":['logo', 'name', 'actions']}})
}
var staticRenderFns = []

export { render, staticRenderFns }